import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Button from "components/CustomButton/CustomButton.jsx";
import { GetGlobalSchedules, UpdateGlobalSchedules } from "../../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../../variables/Variables";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import moment from "moment";
import e from "cors";
import { getApiErrorMessage } from "utils/getApiErrorMessage";


class EditGlobalSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            holiday_day: new Date(),
            holiday_day_err: '',
            isHoliday: '',
            isHallMark: '',
            isCom_err: '',
            errormessages: [],
            currentSch: ''

        };
        this.onSubmit = this.onSubmit.bind(this);
    }


    handleSuccess(position) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "success";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
                <div>
                    <b>Global Schedule</b> - Updated Successfully .
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 3,
        });
        setTimeout(() => {
            this.props.history.push("/admin/globalschedule");
        }, 2000);
    }

    handleNetworkError(position, error) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "error";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
            level: level,
            position: position,
            autoDismiss: 5,
        });
    }

    handleClick(position, message) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "error";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
                <div>
                    <b>{message}</b>.
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5,
        });
    }

    yesterday = moment().subtract(1, 'day')

    disablePastDt = (current) => {
        return current.isAfter(this.yesterday)
    }

    async componentDidMount() {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var id = JSON.parse(localStorage.getItem("hol_id"));

        GetGlobalSchedules(obj, id).then((res) => {
            var data = res.data

            var date = new Date(data.gs_date)
            var isHallMark = false
            var isHoliday = false
            if (data.is_holiday == 1) {
                isHoliday = true
            }
            if (data.is_hallmark_day == 1) {
                isHallMark = true
            }

            this.setState({
                holiday_day: date,
                isHoliday: isHoliday,
                isHallMark: isHallMark,
                currentSch: id
            })
        })

        this.setState({ _notificationSystem: this.refs.notificationSystem });
        setTimeout(
            function () {
                this.setState({ cardHidden: false });
            }.bind(this),
            700
        );
    }


    async onSubmit() {

        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;

        var error = false
        var com_err = ''
        var holiday_err = ''

        if (this.state.holiday_day == '' || this.state.holiday_day == null || this.state.holiday_day == undefined) {
            error = true
            holiday_err = <small className="text-danger">Please select day</small>
        }
        else {
            var support_date = moment(this.state.holiday_day).format('YYYY-MM-DD')
            var current = new Date()
            current = moment(current).format('YYYY-MM-DD')

            if (support_date < current) {
                error = true
                holiday_err = <small className="text-danger">Date should be greater than current date.</small>
            }
            else {
                holiday_err = ''
            }
        }

        if (this.state.isHallMark == false && this.state.isHoliday == false) {
            error = true
            com_err = <small className="text-danger">Please select at least one option.</small>
        }
        else {
            com_err = ''
        }

        this.setState({
            holiday_day_err: holiday_err,
            isCom_err: com_err
        })

        if (!error) {

            var date = moment(this.state.holiday_day).format('YYYY-MM-DD')
            var isHallMark = 0
            var isHoliday = 0

            if (this.state.isHallMark == true) {
                isHallMark = 1
            }
            if (this.state.isHoliday == true) {
                isHoliday = 1
            }

            UpdateGlobalSchedules(obj, this.state.currentSch, date, isHoliday, isHallMark).then((res) => {
                console.log(res)
                if (res.success == true) {
                    this.handleSuccess('bl')
                    localStorage.removeItem('hol_id')
                }
                else {
                    this.handleClick('bl', 'Global Schedule date already available.')
                }
            }).catch((err) => {
                this.handleNetworkError('bl', error)
            })
        }
    };

    handleStartDateChange = (date) => {
        this.setState({
            holiday_day: date,
            holiday_day_err: ''
        })
    }

    handleAllCheckedSlot = (e) => {
        var checked = e.target.checked;
        console.log(checked, e.target.name)
        if (e.target.name == 'isHoliday') {
            this.setState({ isHoliday: checked, isCom_err: '' });
        }
        else if (e.target.name == 'isHallMark') {
            this.setState({ isHallMark: checked, isCom_err: '' });
        }

    };

    render() {
        const errormessages = this.state.errormessages;
        return (
            <div className="main-content">
                <input
                    style={{ width: "0px", height: "0px", border: "none" }}
                    type="text"
                    ref={this.coupon_code_error}
                />
                <Grid fluid>
                    {this.state.alert}
                    <NotificationSystem ref="notificationSystem" style={style} />
                    <Card
                        content={
                            <form>
                                {errormessages.length != 0 && (
                                    <div className=" alert alert-danger">
                                        {errormessages.map((data) => (
                                            <React.Fragment>
                                                <li>{data}</li>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                                <div style={{ maxWidth: '500px' }}>
                                    <FormGroup>
                                        <ControlLabel>Date</ControlLabel>
                                        <Datetime
                                            format="y-MM-dd h:mm:ss"
                                            timeFormat={false}
                                            dateFormat={true}
                                            inputProps={{ placeholder: 'Select Date' }}
                                            defaultValue={this.state.holiday_day}
                                            closeOnSelect={true}
                                            name="holiday_day"
                                            value={this.state.holiday_day}
                                            onChange={this.handleStartDateChange}
                                            className={`datetime-timeselect`}
                                            isValidDate={this.disablePastDt}
                                        />
                                        {this.state.holiday_day_err}
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            number={2}
                                            checked={this.state.isHoliday}
                                            label="Is Holiday ?"
                                            name='isHoliday'
                                            onChange={(e) =>
                                                this.handleAllCheckedSlot(e)
                                            }
                                            value={this.state.isHoliday}
                                            className="is_day_off_checkbox"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            number={1}
                                            checked={this.state.isHallMark}
                                            label="Is Hallmark Holiday ?"
                                            onChange={(e) =>
                                                this.handleAllCheckedSlot(e)
                                            }
                                            name='isHallMark'
                                            value={this.state.isHallMark}
                                            className="is_day_off_checkbox"
                                        />
                                    </FormGroup>
                                    {this.state.isCom_err}
                                </div>

                                <div className="slot_action_group">
                                    <Button
                                        onClick={this.onSubmit.bind(this)}
                                        className="btn-color"
                                        fill
                                    >
                                        Save
                                    </Button>
                                </div>

                            </form>
                        }
                    />

                </Grid>
            </div>
        );
    }
}

export default EditGlobalSchedule;
